import { formatDate } from '@angular/common';
let portalLocale = 'en-GB';

export function setPortalLocale(locale: string): void {
	if (locale) portalLocale = locale;
}

export function portalDate(value: any, format = 'mediumDate'): string {
	if (!value) return '';
	try {
		return formatDate(value, format, portalLocale);
	} catch {
		try {
			return formatDate(value, format, 'en-GB');
		} catch {
			return '' + value;
		}
	}
}
